module.exports = __webpack_public_path__ + "img/bussiness_mobile_hy1.33920f55.png";